import React from "react";
import PropTypes from "prop-types";

import { Button } from "shipnow-mercurio";

import { Styles } from "./MobileFormLayout.styles";

export const MobileFormLayout = (props) => {
  const { children } = props;

  return (
    <Styles.Wrapper>
      <div>{children}</div>

      <div>
        {!!props.cancelButtonProps && (
          <Button fullwidth type="outlined" {...props.cancelButtonProps} />
        )}

        {!!props.confirmButtonProps && (
          <Button fullwidth margin="b-24 t-8" {...props.confirmButtonProps} />
        )}
      </div>
    </Styles.Wrapper>
  );
};

MobileFormLayout.propTypes = {
  cancelButtonProps: PropTypes.object,
  confirmButtonProps: PropTypes.object,
  children: PropTypes.any,
};
